class AddToCartButton extends HTMLButtonElement {
  constructor() {
    super();
    this.handleAddToBag = this.handleAddToBag.bind(this);
  }

  init() {
    this.addEventListener('click', this.handleAddToBag);
    if (!this.dataset.id) {
      this.setAttribute('disabled', 'true');
    }
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleAddToBag);
  }


  handleAddToBag(event) {
    event.preventDefault();
    event.stopPropagation();

    const payload = {
      merchandiseId: `${this.dataset.id}`,
      quantity: 1,
    };

    const cartItems = document.querySelector('cart-drawer-items');
    cartItems.addToCart(payload);
  }
}

if (!customElements.get('add-to-cart-button')) {
  customElements.define('add-to-cart-button', AddToCartButton, { extends: 'button' });
}
